
import { Product, Line } from './types';

export const products: Product[] = [
  // ==========================================
  // PAMPERS (MANTIDO)
  // ==========================================
  // 1. Pampers Confort Sec - RN
  {
    id: 1,
    brand: 'Pampers',
    name: "Fralda Pampers Confort Sec RN",
    line: Line.ConfortSec,
    category: "Tape (Tradicional)",
    size: "RN",
    units: 44, 
    imageUrl: "https://m.media-amazon.com/images/I/61JMOOlw39L._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/3YqhrNO",
    shortDescription: "A primeira fralda do bebê (2-5kg). Corte umbilical especial.",
    fullDescription: "## 🍼 O PRIMEIRO CUIDADO\n\nA primeira fralda do bebê, para recém-nascidos (2-5kg).\n\n### Diferenciais\n- **Corte Umbilical:** Desenho especial que não encosta no umbigo em cicatrização.\n- **Indicador de Xixi:** Avisa quando precisa trocar.",
    keyFeatures: ["Corte Umbilical", "Indicador de Umidade", "2-5kg"],
    seoKeywords: ["fralda rn", "pampers recém nascido", "corte umbilical"]
  },
  // 2. Pampers Premium Care - RN+
  {
    id: 2,
    brand: 'Pampers',
    name: "Fralda Pampers Premium Care RN+ - 20 fraldas",
    line: Line.PremiumCare,
    category: "Tape (Tradicional)",
    size: "RN+",
    units: 20,
    imageUrl: "https://m.media-amazon.com/images/I/61fQR8U0zCL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4q1UHPV",
    shortDescription: "Pacote teste Premium. Loção de camomila e pepino.",
    fullDescription: "## ✨ PACOTE TESTE PREMIUM\n\nLinha premium para pele sensível.\n\n### Suavidade\nPacote pequeno ideal para a mala da maternidade, com loção de camomila e pepino para proteger a pele delicada.",
    keyFeatures: ["Loção de Camomila", "Pele Sensível", "Pacote Teste"],
    seoKeywords: ["premium care rn", "fralda mais suave"]
  },
  // 3. Pampers Confort Sec - M (112 un)
  {
    id: 3,
    brand: 'Pampers',
    name: "Fralda Pampers Confort Sec Tamanho M 112 Fraldas",
    line: Line.ConfortSec,
    category: "Tape (Tradicional)",
    size: "M",
    units: 112,
    imageUrl: "https://m.media-amazon.com/images/I/619WsQ+0muL._AC_SX679_.jpg",
    affiliateUrl: "https://amzn.to/499c37R",
    shortDescription: "Pacote econômico (5-9kg). Ajuste elástico e barreira dupla.",
    fullDescription: "## 💰 ECONOMIA E PROTEÇÃO\n\nPacote econômico para bebês de 5-9kg.\n\n- **Ajuste Elástico:** Se adapta às costas do bebê.\n- **Dupla Barreira:** Proteção extra contra vazamentos nas perninhas.",
    keyFeatures: ["Barreira Dupla", "Ajuste Elástico", "Econômico"],
    seoKeywords: ["pampers m 112", "fralda m barata"]
  },
  // 4. Pampers Confort Sec - M (196 un)
  {
    id: 4,
    brand: 'Pampers',
    name: "Fraldas Pampers Confort Sec M 196 Unidades",
    line: Line.ConfortSec,
    category: "Tape (Tradicional)",
    size: "M",
    units: 196,
    imageUrl: "https://m.media-amazon.com/images/I/71sFW94e1IL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4aa6hUF",
    shortDescription: "O maior pacote M. Tecnologia '2x mais seco e arejado'.",
    fullDescription: "## 📦 ESTOQUE GARANTIDO\n\nO maior pacote disponível no tamanho M.\n\n### Canais de Ar\nFoco em tecnologia 'até 2x mais seco e arejado', permitindo que a pele respire.",
    keyFeatures: ["Pacote Gigante", "Canais de Ar", "Pele Arejada"],
    seoKeywords: ["pampers m atacado", "fralda 196 unidades"]
  },
  // 5. Pampers Confort Sec - G (168 un)
  {
    id: 5,
    brand: 'Pampers',
    name: "Fraldas Pampers Confort Sec G 168 Unidades",
    line: Line.ConfortSec,
    category: "Tape (Tradicional)",
    size: "G",
    units: 168,
    imageUrl: "https://m.media-amazon.com/images/I/71qWE66mi6L._AC_SX679_.jpg",
    affiliateUrl: "https://amzn.to/3KTVF1T", 
    pageUrl: "https://amzn.to/3KTVF1T", 
    shortDescription: "Pacote gigante para a fase ativa (8-14kg).",
    fullDescription: "## 🏃‍♂️ PARA A FASE ATIVA\n\nPacote gigante ideal para bebês de 8 a 14kg que já se movimentam bastante.\n\nGaranta o menor custo por tira comprando em grande quantidade.",
    keyFeatures: ["Pacote Gigante", "8-14kg", "Alta Absorção"],
    seoKeywords: ["pampers g 168", "fralda g promoção"]
  },
  // 6. Pampers Confort Sec - G (98 un)
  {
    id: 6,
    brand: 'Pampers',
    name: "Fralda Pampers Confort Sec G 98 Fraldas",
    line: Line.ConfortSec,
    category: "Tape (Tradicional)",
    size: "G",
    units: 98,
    imageUrl: "https://m.media-amazon.com/images/I/61BYlfOA8tL._AC_SX679_.jpg",
    affiliateUrl: "https://amzn.to/44odM6F",
    shortDescription: "Pacote família. Foco no ajuste elástico nas costas.",
    fullDescription: "## 👨‍👩‍👧‍👦 PACOTE FAMÍLIA\n\nQuantidade intermediária ideal para o orçamento mensal.\n\nO ajuste elástico nas costas garante melhor vedação, evitando vazamentos pelas costas.",
    keyFeatures: ["Ajuste Costas", "Pacote Família", "Vedação Extra"],
    seoKeywords: ["pampers g 98", "fralda g"]
  },
  // 7. Pampers Confort Sec - G (60 un)
  {
    id: 7,
    brand: 'Pampers',
    name: "Fralda Pampers Confort Sec G - 60 fraldas",
    line: Line.ConfortSec,
    category: "Tape (Tradicional)",
    size: "G",
    units: 60,
    imageUrl: "https://m.media-amazon.com/images/I/81lq-otoZ9L._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/48SkC5W",
    shortDescription: "Pacote menor, ideal para testes ou viagens. Proteção noturna.",
    fullDescription: "## 🌙 PROTEÇÃO NOTURNA\n\nPacote menor, ideal para testar se o tamanho G já serve bem ou para repor o estoque de emergência.\n\nÊnfase na proteção para noites tranquilas.",
    keyFeatures: ["Pacote Teste", "Proteção Noturna", "Prático"],
    seoKeywords: ["pampers g pacote pequeno", "fralda g viagem"]
  },
  // 8. Pampers Confort Sec - XG (116 un)
  {
    id: 8,
    brand: 'Pampers',
    name: "Fralda Pampers Confort Sec XG - 116 fraldas",
    line: Line.ConfortSec,
    category: "Tape (Tradicional)",
    size: "XG",
    units: 116,
    imageUrl: "https://m.media-amazon.com/images/I/71XZ+cOcaQL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4q8hVUJ",
    shortDescription: "Para bebês maiores (12-18kg+). Noites inteiras de sono.",
    fullDescription: "## 💤 SONO ININTERRUPTO\n\nPara bebês maiores (12-18kg+).\n\nFoco total em absorção para aguentar o volume maior de xixi e garantir noites inteiras de sono.",
    keyFeatures: ["Alta Capacidade", "12-18kg", "Noites Secas"],
    seoKeywords: ["pampers xg", "fralda xg atacado"]
  },
  // 9. Pampers Confort Sec - XG (148 un)
  {
    id: 9,
    brand: 'Pampers',
    name: "Fraldas Pampers Confort Sec XG 148 Unidades",
    line: Line.ConfortSec,
    category: "Tape (Tradicional)",
    size: "XG",
    units: 148,
    imageUrl: "https://m.media-amazon.com/images/I/71C6P-MXsbL._AC_SX679_.jpg",
    affiliateUrl: "https://amzn.to/44XT0uN",
    shortDescription: "Super pacote com canais de ar. O melhor custo-benefício XG.",
    fullDescription: "## 💨 PELE RESPIRANDO\n\nSuper pacote com tecnologia de canais de ar.\n\nMantém a pele arejada e seca, prevenindo assaduras mesmo em uso prolongado.",
    keyFeatures: ["Super Pacote", "Canais de Ar", "Anti-assaduras"],
    seoKeywords: ["pampers xg 148", "fralda xg barata"]
  },
  // 10. Pampers Confort Sec - XXG (148 un)
  {
    id: 10,
    brand: 'Pampers',
    name: "Fraldas Pampers Confort Sec XXG 148 Unidades",
    line: Line.ConfortSec,
    category: "Tape (Tradicional)",
    size: "XXG",
    units: 148,
    imageUrl: "https://m.media-amazon.com/images/I/71x+xGjgeyL._AC_SX679_.jpg",
    affiliateUrl: "https://amzn.to/4pFRkOY",
    shortDescription: "Maior tamanho disponível (16kg+). Ideal para fase final.",
    fullDescription: "## 🎓 RUMO AO DESFRALDE\n\nMaior tamanho disponível da linha (16kg+).\n\nIdeal para a fase final do uso de fraldas, oferecendo segurança para crianças maiores.",
    keyFeatures: ["Tamanho XXG", "+16kg", "Conforto Max"],
    seoKeywords: ["pampers xxg", "fralda tamanho 6"]
  },
  // 11. Pampers Confort Sec - XG (34 un)
  {
    id: 11,
    brand: 'Pampers',
    name: "Fralda Pampers Confort Sec XG - 34 fraldas",
    line: Line.ConfortSec,
    category: "Tape (Tradicional)",
    size: "XG",
    units: 34,
    imageUrl: "https://m.media-amazon.com/images/I/716Hq9rleYL._AC_SX679_.jpg",
    affiliateUrl: "https://amzn.to/48SfO0i",
    shortDescription: "Pacote pequeno, ideal para teste ou viagens.",
    fullDescription: "## ✈️ IDEAL PARA VIAGEM\n\nPacote compacto que cabe na mala.\n\nPerfeito para viagens de fim de semana ou para deixar na casa dos avós.",
    keyFeatures: ["Portátil", "Pacote Pequeno", "Viagem"],
    seoKeywords: ["pampers xg pequena", "fralda viagem"]
  },
  // 12. Pampers Premium Care (Generico)
  {
    id: 12,
    brand: 'Pampers',
    name: "Fralda Pampers Premium Care",
    line: Line.PremiumCare,
    category: "Tape (Tradicional)",
    size: "Diversos", 
    units: 0, 
    imageUrl: "https://m.media-amazon.com/images/I/617TESrq0lL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/3YrjJw4",
    shortDescription: "Linha top com cobertura tipo tecido. '1 Pampers = 1 noite seco'.",
    fullDescription: "## ⭐ EXPERIÊNCIA SUPERIOR\n\nLinha top de linha da Pampers.\n\n- **Toque de Tecido:** Cobertura externa e interna extremamente suave.\n- **Slogan:** '1 Pampers = 1 noite seco'. Absorção imbatível.",
    keyFeatures: ["Toque de Tecido", "Alta Performance", "Top de Linha"],
    seoKeywords: ["premium care", "melhor pampers"]
  },
  // 13. Pampers Pants Ajuste Total - G
  {
    id: 13,
    brand: 'Pampers',
    name: "Fralda Pampers Pants Ajuste Total G - 144 fraldas",
    line: Line.Pants,
    category: "Pants (Calça)",
    size: "G",
    units: 144,
    imageUrl: "https://m.media-amazon.com/images/I/71fWFuL3nkL._AC_SX679_.jpg",
    affiliateUrl: "https://amzn.to/3XU420l",
    shortDescription: "Fralda-calça fácil de vestir com o bebê em pé.",
    fullDescription: "## 👖 VESTIU, TÁ PRONTO\n\nFralda-calça que facilita a vida dos pais.\n\nIdeal para vestir com o bebê em pé, sem precisar deitar. Possui cintura elástica 360º.",
    keyFeatures: ["Veste em Pé", "Cintura 360", "Praticidade"],
    seoKeywords: ["pampers pants g", "fralda de vestir"]
  },
  // 14. Pampers Premium Care Pants - M
  {
    id: 14,
    brand: 'Pampers',
    name: "Pampers Premium Care Pants Fralda M 124 Unidades",
    line: Line.Pants, 
    category: "Pants (Calça)",
    size: "M",
    units: 124,
    imageUrl: "https://m.media-amazon.com/images/I/610zsSAMtpL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/3MrFGIZ",
    shortDescription: "Pants Premium com 'Nova Barreira Anti-cocô'. Proteção extra.",
    fullDescription: "## 🛡️ BARREIRA ANTI-COCÔ\n\nFralda-calça da linha Premium.\n\nConta com a **Nova Barreira Anti-cocô** para proteção extra nas costas, evitando aquele vazamento indesejado.",
    keyFeatures: ["Premium Pants", "Barreira Anti-cocô", "Suavidade"],
    seoKeywords: ["premium care pants", "fralda calça premium"]
  },
  // 15. Pampers Pants Ajuste Total - M (84 un)
  {
    id: 15,
    brand: 'Pampers',
    name: "Fralda Pampers Pants Ajuste Total M - 84 fraldas",
    line: Line.Pants,
    category: "Pants (Calça)",
    size: "M",
    units: 84,
    imageUrl: "https://m.media-amazon.com/images/I/61qqTGWT+4L._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4p2WtzG",
    shortDescription: "Sistema de Ajuste Inteligente. Canais de ar estruturais.",
    fullDescription: "## 🧠 AJUSTE INTELIGENTE\n\nPossui 'Sistema de Ajuste Inteligente'.\n\nOs canais de ar dão estrutura à fralda, impedindo que ela caia ou fique frouxa conforme o bebê brinca.",
    keyFeatures: ["Ajuste Inteligente", "Não Cai", "Conforto"],
    seoKeywords: ["pants m", "fralda calça m"]
  },
  // 16. Pampers Pants Ajuste Total - M (112 un)
  {
    id: 16,
    brand: 'Pampers',
    name: "Fralda Pampers Pants Ajuste Total M 112 Unidades",
    line: Line.Pants,
    category: "Pants (Calça)",
    size: "M",
    units: 112,
    imageUrl: "https://m.media-amazon.com/images/I/61kHj8Jf52L._AC_SX679_.jpg",
    affiliateUrl: "https://amzn.to/44VakR8",
    shortDescription: "Versão atualizada com 'Nova Barreira Anti-cocô'.",
    fullDescription: "## 🆕 AGORA COM PROTEÇÃO EXTRA\n\nVersão atualizada da Pants Ajuste Total.\n\nAgora conta com a tecnologia 'Nova Barreira Anti-cocô', antes exclusiva da linha Premium, trazendo mais segurança para o dia a dia.",
    keyFeatures: ["Nova Tecnologia", "Barreira Traseira", "Pacote Econômico"],
    seoKeywords: ["pants nova barreira", "pampers m 112 pants"]
  },
  // 17. Pampers Lenços Umedecidos
  {
    id: 17,
    brand: 'Pampers',
    name: "Pampers Cuidado de Bebê Lenços Umedecidos 576 un",
    line: Line.Accessories,
    category: "Lenço",
    units: 576,
    imageUrl: "https://m.media-amazon.com/images/I/61+OonwT8PL._AC_SY450_.jpg",
    affiliateUrl: "https://amzn.to/3MGHmhA",
    shortDescription: "Sem álcool. Dermatologicamente testados.",
    fullDescription: "## 🧼 LIMPEZA SEGURA\n\nLenços sem álcool, dermatologicamente testados.\n\nIdeais para limpar delicadamente a pele do bebê a cada troca. Pacote econômico para durar o mês todo.",
    keyFeatures: ["Sem Álcool", "Hipoalergênico", "Pacote Atacado"],
    seoKeywords: ["lenço umedecido pampers", "lenço sem alcool"],
    notesForDev: "ALERTA: Não usar dentro dos olhos."
  },
  // 18. Pampers Supersec M 90
  {
    id: 18,
    brand: 'Pampers',
    name: "Fralda Pampers Supersec M – 90 fraldas",
    line: Line.Supersec,
    category: "Tape (Tradicional)",
    size: "M",
    units: 90,
    imageUrl: "https://m.media-amazon.com/images/I/617TESrq0lL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/3KTYG22",
    shortDescription: "Fralda Pampers Supersec tamanho M com 90 unidades, desenvolvida para manter o bebê seco durante toda a noite.",
    fullDescription: "## 🌙 1 PAMPERS = 1 NOITE SECO\n\nDesenvolvida para manter seu bebê mais seco do que outras fraldas por uma noite inteira.\n\n### Principais Benefícios\n- **Camada Extra de Absorção:** Impede que o xixi entre em contato com a pele.\n- **Cobertura Tipo Tecido:** Oferece mais conforto.\n- **Magic Gel:** Absorve e retém a umidade dentro da fralda.",
    keyFeatures: ["90 Unidades", "Magic Gel", "Seca a noite toda"],
    seoKeywords: ["pampers supersec m", "fralda economica", "pacote 90"]
  },
  // 19. Pampers Confort Sec P 50
  {
    id: 19,
    brand: 'Pampers',
    name: "Fralda Pampers Confort Sec P – 50 fraldas",
    line: Line.Supersec, 
    category: "Tape (Tradicional)",
    size: "P",
    units: 50,
    imageUrl: "https://m.media-amazon.com/images/I/61d4XyvDRzL._AC_SX679_.jpg",
    affiliateUrl: "https://amzn.to/4rUwdtN",
    shortDescription: "Fralda Pampers Confort Sec tamanho P com 50 unidades, com camada ultra absorvente.",
    fullDescription: "## 🛡️ MÁXIMA PROTEÇÃO A NOITE INTEIRA\n\n- **Camada Ultra Absorvente:** Absorve rapidamente a umidade.\n- **Barreiras Anti Vazamento:** Se adaptam suavemente ao redor das pernas.\n- **Ajuste Cômodo:** Flexível para proteção antivazamentos.",
    keyFeatures: ["50 Unidades", "Camada Ultra Absorvente", "Barreiras Antivazamento"],
    seoKeywords: ["pampers confort sec p", "fralda p", "oferta pampers"]
  },
  // 20. Pampers Supersequinha G 80
  {
    id: 20,
    brand: 'Pampers',
    name: "Fralda Pampers Supersequinha G – 80 fraldas",
    line: Line.Supersec,
    category: "Tape (Tradicional)",
    size: "G",
    units: 80,
    imageUrl: "https://m.media-amazon.com/images/I/61A0SW8AHKL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4oUfkwK",
    shortDescription: "Fralda Pampers Supersequinha tamanho G com 80 unidades, garante até uma noite inteira de proteção.",
    fullDescription: "## ⭐ SUPERSEQUINHA\n\nGarante até uma noite inteira de proteção.\n\n- **1 Pampers = 1 Noite Seco**\n- **Fitas Reajustáveis:** Bastão e de colagem, permitindo ajustar o quanto precisar sem danificar a fralda.\n- **Camada Extra:** Impede o contato do xixi com a pele.",
    keyFeatures: ["80 Unidades", "Magic Gel", "Cobertura Tipo Tecido"],
    seoKeywords: ["pampers supersec g", "supersequinha", "fralda g barata"]
  },
  // ==========================================
  // HUGGIES (TURMA DA MÔNICA)
  // ==========================================
  // LINHA BABY MEGA
  {
    id: 'hug-mega-p-62',
    brand: 'Huggies',
    name: "Huggies Turma da Mônica Tripla Proteção P - 62 Unidades",
    line: Line.TriplaProtecao,
    category: "Tape (Tradicional)",
    size: "P",
    units: 62,
    imageUrl: "https://m.media-amazon.com/images/I/61LlwRI1iIL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/48BQH2R",
    shortDescription: "Linha Baby Mega. Tecnologia Xtra-Flex para bebês ativos.",
    fullDescription: "## 🤸‍♂️ MOVIMENTO LIVRE\n\nFralda Huggies Tripla Proteção com tecnologia **Xtra-Flex**.\n\nOs canais em forma de X se adaptam aos movimentos do bebê, distribuindo o xixi de forma mais uniforme para evitar que a fralda pese ou caia.",
    keyFeatures: ["Linha Baby Mega", "Tecnologia Xtra-Flex", "Tripla Proteção"],
    seoKeywords: ["huggies p", "baby mega", "turma da monica"]
  },
  {
    id: 'hug-mega-m-50',
    brand: 'Huggies',
    name: "Huggies Turma da Mônica Tripla Proteção M - 50 Unidades",
    line: Line.TriplaProtecao,
    category: "Tape (Tradicional)",
    size: "M",
    units: 50,
    imageUrl: "https://m.media-amazon.com/images/I/61g3aZm6yaL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/3L0ws5V",
    shortDescription: "Linha Baby Mega M. Absorção rápida e canais Xtra-Flex.",
    fullDescription: "## ⚡ ABSORÇÃO RÁPIDA\n\nA tecnologia Xtra-Flex oferece flexibilidade total para o bebê brincar à vontade.\n\nPacote Baby Mega com 50 unidades, ideal para o dia a dia.",
    keyFeatures: ["Linha Baby Mega", "Flexibilidade", "Seca Rápido"],
    seoKeywords: ["huggies m", "fralda turma da monica m"]
  },
  {
    id: 'hug-mega-g-44',
    brand: 'Huggies',
    name: "Huggies Turma da Mônica Tripla Proteção G - 44 Unidades",
    line: Line.TriplaProtecao,
    category: "Tape (Tradicional)",
    size: "G",
    units: 44,
    imageUrl: "https://m.media-amazon.com/images/I/61k0GRvVKmL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4iVaJJf",
    shortDescription: "Linha Baby Mega G. Proteção antivazamento.",
    fullDescription: "## 🛡️ BARREIRAS SUPER ALTAS\n\nProteção extra contra vazamentos com barreiras altas.\n\nTamanho G na versão Baby Mega, equilibrando quantidade e preço.",
    keyFeatures: ["Linha Baby Mega", "Barreiras Altas", "Proteção Total"],
    seoKeywords: ["huggies g", "baby mega g"]
  },
  {
    id: 'hug-mega-xg-42',
    brand: 'Huggies',
    name: "Huggies Turma da Mônica Tripla Proteção XG - 42 Unidades",
    line: Line.TriplaProtecao,
    category: "Tape (Tradicional)",
    size: "XG",
    units: 42,
    imageUrl: "https://m.media-amazon.com/images/I/61-HEzvBbXL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4qcVUUR",
    shortDescription: "Linha Baby Mega XG. Conforto para bebês maiores.",
    fullDescription: "## 😌 CONFORTO MÁXIMO\n\nPara bebês maiores que precisam de liberdade.\n\nA tecnologia Xtra-Flex é essencial nessa fase de muitos movimentos e primeiros passos.",
    keyFeatures: ["Linha Baby Mega", "Xtra-Flex", "Bebês Ativos"],
    seoKeywords: ["huggies xg", "fralda xg"]
  },
  // LINHA BABY JUMBO
  {
    id: 'hug-jumbo-m-28',
    brand: 'Huggies',
    name: "Huggies Turma da Mônica Tripla Proteção M - 28 Unidades",
    line: Line.TriplaProtecao,
    category: "Tape (Tradicional)",
    size: "M",
    units: 28,
    imageUrl: "https://m.media-amazon.com/images/I/61yG7GjLvoL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4pBi0jP",
    shortDescription: "Linha Baby Jumbo. Pacote prático e econômico.",
    fullDescription: "## 🎒 PRATICIDADE\n\nPacote Jumbo ideal para levar na bolsa do bebê ou para viagens curtas.\n\nMantém a mesma qualidade Tripla Proteção em um formato mais compacto.",
    keyFeatures: ["Linha Baby Jumbo", "Pacote Prático", "Viagem"],
    seoKeywords: ["huggies jumbo m", "pacote pequeno"]
  },
  {
    id: 'hug-jumbo-g-24',
    brand: 'Huggies',
    name: "Huggies Turma da Mônica Tripla Proteção G - 24 Unidades",
    line: Line.TriplaProtecao,
    category: "Tape (Tradicional)",
    size: "G",
    units: 24,
    imageUrl: "https://m.media-amazon.com/images/I/61gROCZyduL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4iYgDcH",
    shortDescription: "Linha Baby Jumbo G. Ideal para reposição rápida.",
    fullDescription: "## 🔄 REPOSIÇÃO RÁPIDA\n\nAcabou a fralda? O pacote Jumbo é a solução rápida e acessível.\n\nGarante a proteção Huggies com barreiras antivazamento.",
    keyFeatures: ["Linha Baby Jumbo", "Reposição", "Econômico"],
    seoKeywords: ["huggies jumbo g", "fralda g barata"]
  },
  {
    id: 'hug-jumbo-xg-20',
    brand: 'Huggies',
    name: "Huggies Turma da Mônica Tripla Proteção XG - 20 Unidades",
    line: Line.TriplaProtecao,
    category: "Tape (Tradicional)",
    size: "XG",
    units: 20,
    imageUrl: "https://m.media-amazon.com/images/I/61+RhRliTuL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4pDkT3L",
    shortDescription: "Linha Baby Jumbo XG. Compacto e eficiente.",
    fullDescription: "## 🤏 COMPACTO\n\nO menor pacote da linha para o tamanho XG.\n\nIdeal para testar o tamanho ou para ter como emergência no carro ou na casa da vovó.",
    keyFeatures: ["Linha Baby Jumbo", "Emergência", "Teste"],
    seoKeywords: ["huggies jumbo xg", "pacote teste"]
  },
  // LINHA BABY JUMBINHO
  {
    id: 'hug-jumbinho-p-160', 
    brand: 'Huggies',
    name: "Huggies Turma da Mônica Tripla Proteção P - 160 Unidades",
    line: Line.TriplaProtecao,
    category: "Tape (Tradicional)",
    size: "P",
    units: 160,
    imageUrl: "https://m.media-amazon.com/images/I/710+vm4wVQL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4aLDuWy",
    shortDescription: "Pacote Gigante (Jumbinho). Estoque para o mês.",
    fullDescription: "## 📦 ESTOQUE MENSAL\n\nGrande quantidade para garantir tranquilidade.\n\nIdeal para recém-nascidos e bebês pequenos que trocam muitas fraldas por dia.",
    keyFeatures: ["Pacote Gigante", "160 Unidades", "Atacado"],
    seoKeywords: ["huggies atacado", "fralda p 160"]
  },
  {
    id: 'hug-jumbinho-p-20',
    brand: 'Huggies',
    name: "Huggies Turma da Mônica Tripla Proteção P - 20 Unidades",
    line: Line.TriplaProtecao,
    category: "Tape (Tradicional)",
    size: "P",
    units: 20,
    imageUrl: "https://m.media-amazon.com/images/I/61u610lgDYL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4q58R2N",
    shortDescription: "Linha Baby Jumbinho P. Pacote inicial.",
    fullDescription: "## 👶 PRIMEIROS DIAS\n\nPacote pequeno (Jumbinho) ideal para os primeiros dias em casa ou na maternidade.\n\nToque suave e canais de absorção.",
    keyFeatures: ["Linha Baby Jumbinho", "Maternidade", "Pequeno"],
    seoKeywords: ["huggies jumbinho p", "fralda rn"]
  },
  {
    id: 'hug-jumbinho-g-128',
    brand: 'Huggies',
    name: "Huggies Turma da Mônica Tripla Proteção G - 128 Unidades",
    line: Line.TriplaProtecao,
    category: "Tape (Tradicional)",
    size: "G",
    units: 128,
    imageUrl: "https://m.media-amazon.com/images/I/71RNLzPDyzL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4j5bzmH",
    shortDescription: "Pacote Econômico G. 128 tiras de proteção.",
    fullDescription: "## 📉 CUSTO-BENEFÍCIO\n\nReduza o custo por fralda comprando este pacote com 128 unidades.\n\nA tecnologia Xtra-Flex garante que, mesmo cheio, o pacote dure bastante.",
    keyFeatures: ["Pacote Econômico", "128 Unidades", "Xtra-Flex"],
    seoKeywords: ["huggies g 128", "atacado huggies"]
  },
  // LINHA BABY GIGA
  {
    id: 'hug-giga-xg-68',
    brand: 'Huggies',
    name: "Huggies Turma da Mônica Tripla Proteção XG - 68 Unidades",
    line: Line.TriplaProtecao,
    category: "Tape (Tradicional)",
    size: "XG",
    units: 68,
    imageUrl: "https://m.media-amazon.com/images/I/61uf0eDeroL._AC_SX569_.jpg",
    affiliateUrl: "https://www.amazon.com.br/s?k=fralda+huggies+xg+giga", 
    shortDescription: "Linha Baby Giga. O equilíbrio perfeito para o tamanho XG.",
    fullDescription: "## 🐘 LINHA BABY GIGA\n\nPacote Giga oferecendo uma quantidade robusta (68 unidades) para durar várias semanas.\n\nProteção prolongada para bebês grandes.",
    keyFeatures: ["Linha Baby Giga", "68 Unidades", "Durabilidade"],
    seoKeywords: ["huggies giga xg", "pacote giga"]
  },
  // ==========================================
  // HUGGIES (NATURAL CARE & SUPREME CARE)
  // ==========================================
  // Nº 1: Huggies Natural Care RN 34
  {
    id: 'hug-nat-rn-34',
    brand: 'Huggies',
    name: "Fralda Huggies Natural Care RN 34 unidades",
    line: Line.NaturalCare,
    category: "Tape (Tradicional)",
    size: "RN",
    units: 34,
    imageUrl: "https://m.media-amazon.com/images/I/71DAxC1Pu4L._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/459cf4C",
    shortDescription: "Cuidado Puro e Natural. 0% parabenos e fragrâncias.",
    fullDescription: "## 🌱 CUIDADO PURO E NATURAL\n\nCom fibras naturais, materiais suaves e respiráveis.\n\n### Hipoalergênica\nA fralda tem **0% parabenos e fragrâncias**, oferecendo máxima proteção para a pele sensível do recém-nascido. Componentes atóxicos.",
    keyFeatures: ["Fibras Naturais", "0% Parabenos", "Respirável"],
    seoKeywords: ["natural care rn", "huggies rn", "hipoalergenica"]
  },
  // Nº 2: Huggies Supreme Care P 48
  {
    id: 'hug-sup-p-48-a',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care P 48 fraldas",
    line: Line.SupremeCare,
    category: "Tape (Tradicional)",
    size: "P",
    units: 48,
    imageUrl: "https://m.media-amazon.com/images/I/71EGaknfKuL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4iZ9g4C",
    shortDescription: "Até 3x mais seco com camada Maxisec. Novos fechos ajustáveis.",
    fullDescription: "## 🛡️ PROTEÇÃO SUPREMA\n\nAgora com novos fechos ajustáveis, a fralda Supreme Care garante máxima proteção.\n\n- **Camada Maxisec:** Mantém o bebê até 3x mais seco.\n- **Ajuste:** Conforto total para bebês até 6kg.",
    keyFeatures: ["Camada Maxisec", "Fechos Ajustáveis", "Até 6kg"],
    seoKeywords: ["supreme care p", "huggies p 48"]
  },
  // Nº 3: Huggies Supreme Care P 48 (Variação)
  {
    id: 'hug-sup-p-48-b',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care P 48 fraldas (Pack Extra)",
    line: Line.SupremeCare,
    category: "Tape (Tradicional)",
    size: "P",
    units: 48,
    imageUrl: "https://m.media-amazon.com/images/I/71EGaknfKuL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4j4zvGY",
    shortDescription: "Proteção Maxisec P. Conforto para os primeiros meses.",
    fullDescription: "## 🛡️ PROTEÇÃO SUPREMA\n\nGarante a máxima proteção e conforto para seu bebê de até 6kg.\n\nA tecnologia Maxisec absorve o xixi rapidamente, mantendo a pele seca e saudável.",
    keyFeatures: ["Camada Maxisec", "Fechos Ajustáveis", "Conforto"],
    seoKeywords: ["supreme care p", "fralda p huggies"]
  },
  // Nº 4: Huggies Natural Care P 36
  {
    id: 'hug-nat-p-36',
    brand: 'Huggies',
    name: "Huggies Fralda Descartável Natural Care P - 36 Un",
    line: Line.NaturalCare,
    category: "Tape (Tradicional)",
    size: "P",
    units: 36,
    imageUrl: "https://m.media-amazon.com/images/I/71S1KDg3CYL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4iSlID6",
    shortDescription: "Suavidade total com fibras naturais. Canais de respiração.",
    fullDescription: "## 🌿 TOQUE DE NATUREZA\n\nCom canais que ajudam na distribuição da urina e materiais respiráveis.\n\nPara um cuidado Puro e Natural, ideal para peles que precisam de ventilação e suavidade extrema.",
    keyFeatures: ["Fibras Naturais", "Respirável", "Suavidade"],
    seoKeywords: ["natural care p", "huggies natural"]
  },
  // Nº 5: Huggies Supreme Care P 28
  {
    id: 'hug-sup-p-28',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care P 28 unidades",
    line: Line.SupremeCare,
    category: "Tape (Tradicional)",
    size: "P",
    units: 28,
    imageUrl: "https://m.media-amazon.com/images/I/71-gb8rYXIL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4iTbzpX",
    shortDescription: "Absorção especial para cocô líquido. Canais em X.",
    fullDescription: "## 💩 PROTEÇÃO CONTRA COCÔ LÍQUIDO\n\nNova Supreme Care com absorção especial.\n\n- **Canais em X:** Canais flexíveis que se ativam com o movimento.\n- **Distribuição Rápida:** Evita que o xixi se concentre no centro.",
    keyFeatures: ["Canais em X", "Absorção Cocô Líquido", "Flexível"],
    seoKeywords: ["huggies p 28", "supreme care x"]
  },
  // Nº 6: Huggies Supreme Care M 40
  {
    id: 'hug-sup-m-40',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care M - 40 fraldas",
    line: Line.SupremeCare,
    category: "Tape (Tradicional)",
    size: "M",
    units: 40,
    imageUrl: "https://m.media-amazon.com/images/I/71m-sNFETuL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4af7t9b",
    shortDescription: "Até 3x mais seco dia e noite. 4 pontos de ajuste.",
    fullDescription: "## ☀️ DIA E NOITE 🌙\n\nCom 4 pontos de ajuste que ajudam a prevenir vazamentos pelas costas.\n\nTecnologia Maxisec garante até 12 horas de proteção (pode variar de acordo com hábitos).",
    keyFeatures: ["4 Pontos Ajuste", "Dia e Noite", "Maxisec"],
    seoKeywords: ["supreme care m", "huggies m 40"]
  },
  // Nº 7: Huggies Supreme Care M 72
  {
    id: 'hug-sup-m-72',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care M 72 unidades",
    line: Line.SupremeCare,
    category: "Tape (Tradicional)",
    size: "M",
    units: 72,
    imageUrl: "https://m.media-amazon.com/images/I/81sROrzrTEL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4qdBhId",
    shortDescription: "Tecnologia Xtra-Flex: canais em X que não deixam a fralda cair.",
    fullDescription: "## 🤸 XTRA-FLEX: MOVIMENTO LIVRE\n\nExclusiva tecnologia **Xtra-Flex** mantém a fralda ajustada mesmo quando o bebê se move.\n\n- **2x Mais Proteção Noturna:** Barreira avançada para noites secas.\n- **Canais Anatômicos:** Se adaptam entre as perninhas.",
    keyFeatures: ["Xtra-Flex", "Não Cai", "2x Proteção Noturna"],
    seoKeywords: ["huggies m 72", "supreme care xtra flex"]
  },
  // Nº 8: Huggies Pants Supreme Care M 72 (Linha Pants para ficar na categoria certa, mas marca Huggies)
  {
    id: 'hug-pants-m-72',
    brand: 'Huggies',
    name: "Fralda Pants Huggies Supreme Care M 72 unidades",
    line: Line.Pants,
    category: "Pants (Calça)",
    size: "M",
    units: 72,
    imageUrl: "https://m.media-amazon.com/images/I/818MarZ6OOL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/3KWgqKi",
    shortDescription: "Proteção Acolchoada. Veste como shortinho.",
    fullDescription: "## ☁️ PROTEÇÃO ACOLCHOADA\n\nFralda Supreme Care estilo roupinha.\n\n- **Cintura Macia:** Previne marquinhas na pele do bebê.\n- **Fácil de Vestir:** Ideal para bebês que não param na troca.",
    keyFeatures: ["Cintura Acolchoada", "Veste Fácil", "Supreme Care"],
    seoKeywords: ["huggies pants m", "fralda shortinho"]
  },
  // Nº 9: Huggies Supreme Care Roupinha M 36
  {
    id: 'hug-roup-m-36',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care Roupinha M - 36 fraldas",
    line: Line.Pants,
    category: "Pants (Calça)",
    size: "M",
    units: 36,
    imageUrl: "https://m.media-amazon.com/images/I/71H11HwAU3L._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/49bfBqg",
    shortDescription: "Praticidade do formato roupinha com absorção Maxisec.",
    fullDescription: "## 👖 SUPREME CARE ROUPINHA\n\nRecomendado para crianças de 5,5 a 9,5 kg.\n\nCom 4 pontos de ajuste e cintura elástica, previne vazamentos pelas costas enquanto oferece a facilidade de vestir como uma calça.",
    keyFeatures: ["Formato Roupinha", "Maxisec", "Ajuste Costas"],
    seoKeywords: ["huggies roupinha m", "pants m"]
  },
  // Nº 10: Huggies Supreme Care G 32
  {
    id: 'hug-sup-g-32',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care G - 32 fraldas",
    line: Line.SupremeCare,
    category: "Tape (Tradicional)",
    size: "G",
    units: 32,
    imageUrl: "https://m.media-amazon.com/images/I/71hatSveZWL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4oR6iQU",
    shortDescription: "Máxima proteção e conforto. Fechos ajustáveis.",
    fullDescription: "## 🛡️ CAMADA MAXISEC\n\nPara bebês de 9 a 12,5 kg.\n\nOferece proteção superior contra vazamentos com sua camada exclusiva de absorção e fechos que se adaptam à barriguinha.",
    keyFeatures: ["Maxisec", "Fechos Ajustáveis", "G 32 Un"],
    seoKeywords: ["supreme care g", "huggies g"]
  },
  // Nº 11: Huggies Supreme Care Roupinha G 60
  {
    id: 'hug-roup-g-60',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care Roupinha G - 60 fraldas",
    line: Line.Pants,
    category: "Pants (Calça)",
    size: "G",
    units: 60,
    imageUrl: "https://m.media-amazon.com/images/I/81XM69oIvoL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4q1tH34",
    shortDescription: "Pacote grande de fralda roupinha G. 3x mais seco.",
    fullDescription: "## 🔄 TROCA FÁCIL EM GRANDE QUANTIDADE\n\nPacote com 60 unidades da versão Roupinha.\n\nIdeal para a fase em que o bebê começa a explorar o mundo e não quer deitar para trocar a fralda.",
    keyFeatures: ["Pacote 60", "Roupinha", "3x Mais Seco"],
    seoKeywords: ["huggies roupinha g", "pants g 60"]
  },
  // Nº 12: Huggies Supreme Care G 64
  {
    id: 'hug-sup-g-64',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care G - 64 Fraldas",
    line: Line.SupremeCare,
    category: "Tape (Tradicional)",
    size: "G",
    units: 64,
    imageUrl: "https://m.media-amazon.com/images/I/61J4UNGTTbL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/3KG2unH",
    shortDescription: "Pacote econômico Supreme Care G.",
    fullDescription: "## 💰 ECONOMIA NO TAMANHO G\n\nGaranta mais fraldas por pacote.\n\nCom novos fechos ajustáveis e camada Maxisec, seu bebê fica seco por mais tempo, permitindo noites de sono ininterruptas.",
    keyFeatures: ["Pacote Econômico", "Fechos Ajustáveis", "Maxisec"],
    seoKeywords: ["huggies g 64", "oferta huggies g"]
  },
  // Nº 13: Huggies Supreme Care Roupinha G 30
  {
    id: 'hug-roup-g-30',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care Roupinha G - 30 fraldas",
    line: Line.Pants,
    category: "Pants (Calça)",
    size: "G",
    units: 30,
    imageUrl: "https://m.media-amazon.com/images/I/71Ixde1c-eL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/48CFKOH",
    shortDescription: "Pacote prático de fralda roupinha. Ajuste perfeito.",
    fullDescription: "## 👖 AJUSTE PERFEITO\n\nA fralda que veste como calcinha/cuequinha.\n\nPerfeita para levar na bolsa ou para testar a adaptação do bebê ao modelo pants.",
    keyFeatures: ["Roupinha", "Prático", "Ajuste"],
    seoKeywords: ["huggies pants g pequena", "roupinha g"]
  },
  // Nº 14: Huggies Supreme Care G 20
  {
    id: 'hug-sup-g-20',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care G - 20 Fraldas",
    line: Line.SupremeCare,
    category: "Tape (Tradicional)",
    size: "G",
    units: 20,
    imageUrl: "https://m.media-amazon.com/images/I/71A8nPwqxaL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/3YvGPBG",
    shortDescription: "Pacote pequeno G. Personalizadas Turma da Mônica.",
    fullDescription: "## 🎒 IDEAL PARA O PASSEIO\n\nPacote compacto com 20 unidades.\n\nPersonalizadas com a Turma da Mônica, trazendo diversão para a hora da troca. Até 3x mais seco.",
    keyFeatures: ["Pacote Passeio", "Turma da Mônica", "3x Mais Seco"],
    seoKeywords: ["huggies g 20", "pacote pequeno"]
  },
  // Nº 15: Huggies Supreme Care XG 140
  {
    id: 'hug-sup-xg-140',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care XG 140 unidades",
    line: Line.SupremeCare,
    category: "Tape (Tradicional)",
    size: "XG",
    units: 140,
    imageUrl: "https://m.media-amazon.com/images/I/81kCJKbN01L._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/3KPFhzs",
    shortDescription: "Mega estoque XG com tecnologia Xtra-Flex. Não cai.",
    fullDescription: "## 📦 ESTOQUE GIGANTE\n\nGaranta tranquilidade com 140 unidades.\n\nConta com a tecnologia **Xtra-Flex**: canais em X que distribuem o xixi para a fralda não pesar e não cair entre as pernas.",
    keyFeatures: ["Estoque 140", "Xtra-Flex", "Não Cai"],
    seoKeywords: ["huggies xg atacado", "fralda xg 140"]
  },
  // Nº 16: Huggies Supreme Care XG 58
  {
    id: 'hug-sup-xg-58',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care XG 58 unidades",
    line: Line.SupremeCare,
    category: "Tape (Tradicional)",
    size: "XG",
    units: 58,
    imageUrl: "https://m.media-amazon.com/images/I/81YgiOHBpaL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/48LBMU1",
    shortDescription: "2x mais proteção noturna. Canais Xtra-Flex.",
    fullDescription: "## 🌙 NOITES TRANQUILAS\n\nOferece o dobro de proteção noturna comparado à versão anterior.\n\nCintura, barreiras e orelhas elásticas garantem máxima flexibilidade para bebês maiores e ativos.",
    keyFeatures: ["Proteção Noturna", "Xtra-Flex", "Elástica"],
    seoKeywords: ["huggies xg 58", "supreme care xg"]
  },
  // Nº 17: Huggies Pants Supreme Care XG 64
  {
    id: 'hug-pants-xg-64',
    brand: 'Huggies',
    name: "Fralda Pants Huggies Supreme Care XG 64 unidades",
    line: Line.Pants,
    category: "Pants (Calça)",
    size: "XG",
    units: 64,
    imageUrl: "https://m.media-amazon.com/images/I/81rfab7At1L._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4rT2pxC",
    shortDescription: "Maior cobertura do bumbum. Proteção acolchoada.",
    fullDescription: "## 🍑 MAIOR COBERTURA\n\nQuando comparado com versões anteriores, oferece maior cobertura do bumbum.\n\n12h de extra proteção com máxima flexibilidade e conforto da cintura acolchoada.",
    keyFeatures: ["Cobertura Total", "Cintura Acolchoada", "12h Proteção"],
    seoKeywords: ["pants xg", "huggies calça xg"]
  },
  // Nº 18: Huggies Supreme Care Roupinha XG 24
  {
    id: 'hug-roup-xg-24',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care Roupinha XG - 24 fraldas",
    line: Line.Pants,
    category: "Pants (Calça)",
    size: "XG",
    units: 24,
    imageUrl: "https://m.media-amazon.com/images/I/61pK5g6qjNL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4j1AWGa",
    shortDescription: "Pacote prático Roupinha XG. Trocas rápidas.",
    fullDescription: "## ⚡ TROCAS RÁPIDAS\n\nSistema simplificado 'vestiu, tá pronto'.\n\nIdeal para crianças de 12 a 15 kg. Camada de proteção Maxisec dia e noite.",
    keyFeatures: ["Roupinha XG", "Troca Rápida", "Maxisec"],
    seoKeywords: ["huggies pants xg 24", "fralda xg"]
  },
  // Nº 19: Huggies Supreme Care XG 26
  {
    id: 'hug-sup-xg-26',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care XG - 26 fraldas",
    line: Line.SupremeCare,
    category: "Tape (Tradicional)",
    size: "XG",
    units: 26,
    imageUrl: "https://m.media-amazon.com/images/I/71U3rbi6YML._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4oTs7iP",
    shortDescription: "Tecnologia X-Flex e sistema abre e fecha macio.",
    fullDescription: "## 👐 ABRE E FECHA FÁCIL\n\nFechos macios que não machucam o bebê.\n\nA tecnologia X-Flex permite que a fralda fique mais seca e tenha melhor sistema antivazamento.",
    keyFeatures: ["X-Flex", "Abre e Fecha", "Antivazamento"],
    seoKeywords: ["huggies xg 26", "pacote pequeno"]
  },
  // Nº 20: Huggies Supreme Care XXG 140
  {
    id: 'hug-sup-xxg-140',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care XXG 140 unidades",
    line: Line.SupremeCare,
    category: "Tape (Tradicional)",
    size: "XXG",
    units: 140,
    imageUrl: "https://m.media-amazon.com/images/I/81Dy1eSI63L._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/44pYApJ",
    shortDescription: "Suavidade sem precedentes. Estoque XXG.",
    fullDescription: "## ☁️ A MAIS SUAVE\n\nDestaca-se como a opção mais macia do mercado.\n\nPacote gigante para o tamanho XXG, com canais em X que se adaptam aos movimentos de crianças maiores.",
    keyFeatures: ["Super Macia", "Estoque 140", "Xtra-Flex"],
    seoKeywords: ["huggies xxg atacado", "fralda tamanho 6"]
  },
  // Nº 21: Huggies Pants Supreme Care XXG 48
  {
    id: 'hug-pants-xxg-48',
    brand: 'Huggies',
    name: "Fralda Pants Huggies Supreme Care XXG 48 unidades",
    line: Line.Pants,
    category: "Pants (Calça)",
    size: "XXG",
    units: 48,
    imageUrl: "https://m.media-amazon.com/images/I/81UdBUsvE9L._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4iVe9vi",
    shortDescription: "Liberdade total de movimento. Cintura 360 macia.",
    fullDescription: "## 🏃 LIBERDADE XXG\n\nPara crianças maiores que precisam de liberdade total.\n\nA cintura elástica e os canais Xtra-Flex garantem movimentos anatômicos sem apertar ou marcar a pele.",
    keyFeatures: ["Liberdade", "Cintura Macia", "XXG"],
    seoKeywords: ["pants xxg", "huggies calça xxg"]
  },
  // Nº 22: Huggies Supreme Care XXG 58
  {
    id: 'hug-sup-xxg-58',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care XXG 58 unidades",
    line: Line.SupremeCare,
    category: "Tape (Tradicional)",
    size: "XXG",
    units: 58,
    imageUrl: "https://m.media-amazon.com/images/I/81wiOY1rBhL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4aaVrh9",
    shortDescription: "Máxima proteção sem fralda caída. Canais em X.",
    fullDescription: "## 🚫 SEM FRALDA CAÍDA\n\nOs canais em X distribuem o xixi de forma inteligente.\n\nIsso evita aquele aspecto de fralda caída que atrapalha o caminhar da criança.",
    keyFeatures: ["Não Cai", "Distribuição X", "XXG"],
    seoKeywords: ["huggies xxg 58", "supreme care xxg"]
  },
  // Nº 23: Huggies Supreme Care XXG 26
  {
    id: 'hug-sup-xxg-26',
    brand: 'Huggies',
    name: "Fralda Huggies Supreme Care XXG - 26 fraldas",
    line: Line.SupremeCare,
    category: "Tape (Tradicional)",
    size: "XXG",
    units: 26,
    imageUrl: "https://m.media-amazon.com/images/I/71-8HxrKXDL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/3METi3p",
    shortDescription: "Pacote prático XXG. Tecnologia X-Flex.",
    fullDescription: "## 🎯 PRATICIDADE XXG\n\nPacote ideal para viagens ou passeios com crianças maiores.\n\nGarante a mesma tecnologia X-Flex dos pacotes maiores, mantendo a criança seca e confortável.",
    keyFeatures: ["Pacote Prático", "X-Flex", "XXG"],
    seoKeywords: ["huggies xxg pequena", "fralda xxg"]
  },
  // ==========================================
  // BABYSEC (GALINHA PINTADINHA & PREMIUM)
  // ==========================================
  // 1. Babysec Ultrasec Galinha Pintadinha P 42 Unidades
  {
    id: 'babysec-ultra-p-42',
    brand: 'Babysec',
    name: "Fralda Babysec Ultrasec Galinha Pintadinha, P, 42 Unidades",
    line: Line.Ultrasec,
    category: "Tape (Tradicional)",
    size: "P",
    units: 42,
    imageUrl: "https://m.media-amazon.com/images/I/617zmUT1myL._AC_SX425_.jpg",
    affiliateUrl: "https://amzn.to/3MAX9yB",
    shortDescription: "Leve a diversão e a proteção confiável da Galinha Pintadinha.",
    fullDescription: "## 🐔 DIVERSÃO E PROTEÇÃO\n\nEsta edição especial combina a segurança de uma absorção de longa duração (até 12h) com o mundo encantador da Galinha Pintadinha.\n\nSeu design possui gel extra absorvente, barreiras impermeáveis e fechos reposicionáveis.",
    keyFeatures: ["Galinha Pintadinha", "12h Proteção", "Fechos Reposicionáveis"],
    seoKeywords: ["babysec p", "galinha pintadinha", "ultrasec"]
  },
  // 2. Babysec Ultrasec Galinha Pintadinha M 38 Unidades (Azul)
  {
    id: 'babysec-ultra-m-38',
    brand: 'Babysec',
    name: "Babysec Fralda Ultrasec Galinha Pintadinha Azul M 38 Unidades",
    line: Line.Ultrasec,
    category: "Tape (Tradicional)",
    size: "M",
    units: 38,
    imageUrl: "https://m.media-amazon.com/images/I/612FCvCPlvL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4rZy1l4",
    shortDescription: "Garanta até 12 horas de proteção. Ideal para bebês de 5 a 9,5 kg.",
    fullDescription: "## 💙 PROTEÇÃO AZUL\n\nOferece absorção eficiente com gel extra absorvente.\n\nPossui barreiras impermeáveis e fechos reposicionáveis para ajuste personalizado.",
    keyFeatures: ["Gel Extra Absorvente", "5 a 9,5 kg", "Barreiras Impermeáveis"],
    seoKeywords: ["babysec m azul", "fralda galinha pintadinha"]
  },
  // 3. Babysec Ultrasec Galinha Pintadinha M 72 Unidades
  {
    id: 'babysec-ultra-m-72',
    brand: 'Babysec',
    name: "Babysec Fraldas Descartáveis Ultrasec Galinha Pintadinha, M, 72 Unidades",
    line: Line.Ultrasec,
    category: "Tape (Tradicional)",
    size: "M",
    units: 72,
    imageUrl: "https://m.media-amazon.com/images/I/71ZZb66C4NL._AC_SX425_.jpg",
    affiliateUrl: "https://amzn.to/4pEBDaE",
    shortDescription: "Mega pacote econômico com 72 unidades. Tecnologia Ultrasec.",
    fullDescription: "## 📦 MEGA PACOTE ECONÔMICO\n\nPacote com 72 unidades para garantir o estoque.\n\nOferece proteção de até 12 horas com a tecnologia Ultrasec (gel extra absorvente e barreiras impermeáveis) e o tema divertido da Galinha Pintadinha Azul.",
    keyFeatures: ["Pacote 72", "Tecnologia Ultrasec", "Econômico"],
    seoKeywords: ["babysec m 72", "mega pacote babysec"]
  },
  // 4. Babysec Ultrasec Galinha Pintadinha M 18 Unidades
  {
    id: 'babysec-ultra-m-18',
    brand: 'Babysec',
    name: "Babysec Fralda Ultrasec Galinha Pintadinha M 18 Unidades",
    line: Line.Ultrasec,
    category: "Tape (Tradicional)",
    size: "M",
    units: 18,
    imageUrl: "https://m.media-amazon.com/images/I/81TvS259TTL._AC_SX425_.jpg",
    affiliateUrl: "https://amzn.to/4aQYDPc",
    shortDescription: "Pacote menor ideal para teste ou viagens. Tamanho M.",
    fullDescription: "## ✈️ IDEAL PARA VIAGEM\n\nPacote compacto com 18 unidades.\n\nPerfeito para levar na bolsa de passeio ou para testar a adaptação do bebê à marca Babysec.",
    keyFeatures: ["Pacote Teste", "Portátil", "Galinha Pintadinha"],
    seoKeywords: ["babysec m pequena", "teste babysec"]
  },
  // 5. Babysec Ultrasec Galinha Pintadinha G 32 Unidades
  {
    id: 'babysec-ultra-g-32',
    brand: 'Babysec',
    name: "Babysec Ultrasec Galinha Pintadinha - Fralda, Tamanho G, 32 Unidades",
    line: Line.Ultrasec,
    category: "Tape (Tradicional)",
    size: "G",
    units: 32,
    imageUrl: "https://m.media-amazon.com/images/I/51rLa23uplL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4j8xlpF",
    shortDescription: "Fralda tamanho G com cobertura suave e proteção de até 12 horas.",
    fullDescription: "## 🛡️ PROTEÇÃO G\n\nOferece barreiras impermeáveis e fechos reposicionáveis com o tema Galinha Pintadinha.\n\n*Atenção: Produto sofreu alteração de quantidade (era G34, agora é G32).*",
    keyFeatures: ["Tamanho G", "Cobertura Suave", "Fechos Reposicionáveis"],
    seoKeywords: ["babysec g", "fralda g barata"]
  },
  // 6. Babysec Premium Galinha Pintadinha P 34 Unidades
  {
    id: 'babysec-prem-p-34',
    brand: 'Babysec',
    name: "Babysec Fralda Galinha Pintadinha Premium P 34 Unidades",
    line: Line.BabysecPremium,
    category: "Tape (Tradicional)",
    size: "P",
    units: 34,
    imageUrl: "https://m.media-amazon.com/images/I/51dsvtf4o1L._AC_SX425_.jpg",
    affiliateUrl: "https://amzn.to/498UrZT",
    shortDescription: "Fralda Premium com cobertura de algodão para toque extra macio.",
    fullDescription: "## ⭐ TOQUE DE ALGODÃO\n\nCombina a qualidade superior da linha Premium com as estampas da Galinha Pintadinha.\n\nFoca no bem-estar e na saúde do bebê com materiais respiráveis e suaves.",
    keyFeatures: ["Premium", "Toque Algodão", "Suavidade"],
    seoKeywords: ["babysec premium p", "fralda macia"]
  },
  // 7. Babysec Premium Galinha Pintadinha G 26 Unidades (Flexi Protect)
  {
    id: 'babysec-prem-g-26',
    brand: 'Babysec',
    name: "Babysec Fraldas Premium Galinha Pintadinha Flexi Protect G 26 Unidades",
    line: Line.BabysecPremium,
    category: "Tape (Tradicional)",
    size: "G",
    units: 26,
    imageUrl: "https://m.media-amazon.com/images/I/51ZSVFKI2dL._AC_SX425_.jpg",
    affiliateUrl: "https://amzn.to/4oYt3me",
    shortDescription: "Tecnologia Flexi Protect com cintura e orelhas elásticas.",
    fullDescription: "## 🤸 FLEXI PROTECT\n\nPermite movimento total para o bebê.\n\nTamanho G com proteção 12h, gel extra absorvente, fechos reposicionáveis e tema Galinha Pintadinha.",
    keyFeatures: ["Flexi Protect", "Cintura Elástica", "Movimento Livre"],
    seoKeywords: ["babysec premium g", "flexi protect"]
  },
  // 8. Babysec Premium M 32 Unidades (Sem Estampa/Padrão)
  {
    id: 'babysec-prem-m-32',
    brand: 'Babysec',
    name: "Babysec Fralda Premium M 32 Unidades",
    line: Line.BabysecPremium,
    category: "Tape (Tradicional)",
    size: "M",
    units: 32,
    imageUrl: "https://m.media-amazon.com/images/I/512mbN+Sq+L._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4rY7ULn",
    shortDescription: "Proteção dia e noite de até 12 horas. Cintura elástica.",
    fullDescription: "## ☀️ DIA E NOITE 🌙\n\nPossui cintura e orelha elástica, fechos reposicionáveis e gel extra absorvente para conforto e segurança máximos durante todo o dia.",
    keyFeatures: ["Cintura Elástica", "Dia e Noite", "Gel Extra Absorvente"],
    seoKeywords: ["babysec premium m", "fralda premium"]
  },

  // ==========================================
  // MAMYPOKO (NOVA LISTA INTEGRADA)
  // ==========================================
  
  // 1. MamyPoko Fralda-Calça RN Jumbo – 36 un
  {
    id: 'mamy-rn-jumbo-36',
    brand: 'Mamypoko',
    name: "MamyPoko Fralda-Calça RN Jumbo – 36 un",
    line: Line.MamyPokoFraldaCalca,
    category: "Pants (Calça)",
    size: "RN",
    units: 36,
    imageUrl: "https://m.media-amazon.com/images/I/71OTuERCh7L._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4oSAyuD",
    shortDescription: "Primeira fralda-calça RN. Furinhos arejados e conforto total.",
    fullDescription: "## 👖 A PRIMEIRA FRALDA-CALÇA RN\n\nIndicada para bebês até 5kg. \n\n- **Furinhos Arejados:** Na cintura para liberar umidade.\n- **Caminhos de Ar:** Melhora a ventilação e previne assaduras.\n- **Alta Absorção:** Absorve até 5 copos (1 copo=25ml), mantendo o bebê sequinho.",
    keyFeatures: ["Fralda-Calça RN", "Até 5kg", "Furinhos Arejados"],
    seoKeywords: ["mamypoko rn", "fralda calça rn", "mamy poko"]
  },
  // 2. MamyPoko Fralda-Calça RN Regular – 20 un
  {
    id: 'mamy-rn-reg-20',
    brand: 'Mamypoko',
    name: "MamyPoko Fralda-Calça RN Regular – 20 un",
    line: Line.MamyPokoFraldaCalca,
    category: "Pants (Calça)",
    size: "RN",
    units: 20,
    imageUrl: "https://m.media-amazon.com/images/I/71wtxmMu2cL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/49eeQwz",
    shortDescription: "Pacote regular RN. Fácil de vestir e super seca.",
    fullDescription: "## 🌬️ COBERTURA SUPER SECA\n\nPara bebês até 5kg.\n\nA fralda-calça que ajusta sozinha ao corpo, garantindo praticidade desde os primeiros dias.\n\nPossui caminhos de ar e furinhos arejados na cintura.",
    keyFeatures: ["Fralda-Calça", "Fácil de Vestir", "Super Seca"],
    seoKeywords: ["mamypoko rn 20", "pacote pequeno"]
  },
  // 3. MamyPoko Fralda-Calça Dia & Noite P – 46 un
  {
    id: 'mamy-dn-p-46',
    brand: 'Mamypoko',
    name: "MamyPoko Fralda-Calça Dia & Noite P – 46 un",
    line: Line.MamyPokoDiaNoite,
    category: "Pants (Calça)",
    size: "P",
    units: 46,
    imageUrl: "https://m.media-amazon.com/images/I/61RRHokQEvL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4iZBFY5",
    shortDescription: "Proteção prolongada até 12h. Barreira dupla.",
    fullDescription: "## ☀️ DIA & NOITE 🌙\n\nProteção prolongada para garantir o sono tranquilo.\n\n- **Absorção:** Até 4 copos (1 copo=30ml).\n- **Segurança:** Barreira dupla contra vazamentos laterais.\n- **Praticidade:** Fita de descarte para facilitar a troca.",
    keyFeatures: ["Até 12h", "Barreira Dupla", "Fita de Descarte"],
    seoKeywords: ["mamypoko dia e noite p", "fralda p"]
  },
  // 4. MamyPoko Fralda-Calça Premium Seca P – 46 un
  {
    id: 'mamy-prem-p-46',
    brand: 'Mamypoko',
    name: "MamyPoko Fralda-Calça Premium Seca P – 46 un",
    line: Line.MamyPokoPremium,
    category: "Pants (Calça)",
    size: "P",
    units: 46,
    imageUrl: "https://m.media-amazon.com/images/I/71LBEiSNcAL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/3KTnFCE",
    shortDescription: "Ultra macia como algodão. Micro poros que respiram.",
    fullDescription: "## ⭐ PREMIUM SECA\n\nPara bebês de 3 a 9kg.\n\nToque ultra macio (suave como algodão) com micro poros e furinhos arejados que ajudam a liberar calor e umidade, mantendo o bebê seco por até 12h.",
    keyFeatures: ["Suave como Algodão", "Micro Poros", "3 a 9kg"],
    seoKeywords: ["mamypoko premium p", "fralda macia"]
  },
  // 5. MamyPoko Fralda-Calça Premium Seca P – 24 un
  {
    id: 'mamy-prem-p-24',
    brand: 'Mamypoko',
    name: "MamyPoko Fralda-Calça Premium Seca P – 24 un",
    line: Line.MamyPokoPremium,
    category: "Pants (Calça)",
    size: "P",
    units: 24,
    imageUrl: "https://m.media-amazon.com/images/I/710YxmhotGL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4qfu0Yk",
    shortDescription: "Cintura elástica que estica 2x. Proteção dupla.",
    fullDescription: "## 🤸 LIBERDADE DE MOVIMENTO\n\nIndicada para bebês de 3 a 8kg.\n\nCintura elástica confortável que estica até 2x, facilitando a troca e garantindo conforto. Proteção dupla nas pernas contra vazamentos.",
    keyFeatures: ["Estica 2x", "Proteção Dupla", "Premium"],
    seoKeywords: ["mamypoko premium p 24", "pacote pequeno"]
  },
  // 6. MamyPoko Fralda-Calça Premium Seca M – 68 un
  {
    id: 'mamy-prem-m-68',
    brand: 'Mamypoko',
    name: "MamyPoko Fralda-Calça Premium Seca M – 68 un",
    line: Line.MamyPokoPremium,
    category: "Pants (Calça)",
    size: "M",
    units: 68,
    imageUrl: "https://m.media-amazon.com/images/I/71T6XFv+kfL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/3KNM4ty",
    shortDescription: "Ondas de absorção imediata. Ótima para a noite.",
    fullDescription: "## 🌊 ONDAS DE ABSORÇÃO\n\nPara bebês de 6 a 10kg.\n\nTecnologia exclusiva com ondas de absorção que retêm o xixi imediatamente. Absorve até 5 copos (1 copo=40ml) garantindo 12h de pele seca.",
    keyFeatures: ["Ondas de Absorção", "Até 5 Copos", "Uso Noturno"],
    seoKeywords: ["mamypoko premium m", "fralda noturna"]
  },
  // 7. MamyPoko Fralda-Calça Dia & Noite M – 34 un
  {
    id: 'mamy-dn-m-34',
    brand: 'Mamypoko',
    name: "MamyPoko Fralda-Calça Dia & Noite M – 34 un",
    line: Line.MamyPokoDiaNoite,
    category: "Pants (Calça)",
    size: "M",
    units: 34,
    imageUrl: "https://m.media-amazon.com/images/I/71LmUm88gWL._AC_SX300_SY300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/4aPGEZl",
    shortDescription: "Proteção noite toda. Absorve até 4 copos.",
    fullDescription: "## 💤 SONO TRANQUILO\n\nPara bebês de 6 a 10kg.\n\nGarante proteção a noite toda com até 12h de absorção (até 4 copos de 40ml). Barreira dupla e fita de descarte.",
    keyFeatures: ["Dia & Noite", "Até 4 Copos", "Barreira Dupla"],
    seoKeywords: ["mamypoko dia e noite m", "fralda barata"]
  },
  // 8. MamyPoko Fralda-Calça Dia & Noite M – 18 un
  {
    id: 'mamy-dn-m-18',
    brand: 'Mamypoko',
    name: "MamyPoko Fralda-Calça Dia & Noite M – 18 un",
    line: Line.MamyPokoDiaNoite,
    category: "Pants (Calça)",
    size: "M",
    units: 18,
    imageUrl: "https://m.media-amazon.com/images/I/71HVsMLQ-vL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/48UsT99",
    shortDescription: "Pacote prático M. Ajusta sozinha ao corpo.",
    fullDescription: "## 👖 AJUSTE PERFEITO\n\nPara bebês de 7 a 10kg.\n\nFralda fácil de vestir que ajusta sozinha ao corpo do bebê. Cintura elástica que estica até 2x para total liberdade.",
    keyFeatures: ["Ajuste Automático", "Cintura Elástica", "Prático"],
    seoKeywords: ["mamypoko m 18", "pacote viagem"]
  },
  // 9. MamyPoko Fralda-Calça Dia & Noite G – 50 un
  {
    id: 'mamy-dn-g-50',
    brand: 'Mamypoko',
    name: "MamyPoko Fralda-Calça Dia & Noite G – 50 un",
    line: Line.MamyPokoDiaNoite,
    category: "Pants (Calça)",
    size: "G",
    units: 50,
    imageUrl: "https://m.media-amazon.com/images/I/715xNA-HXrL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/3L1NL6E",
    shortDescription: "Pacote econômico G. Ideal para uso noturno.",
    fullDescription: "## 🌙 ESPECIALISTA EM NOITE\n\nPara bebês de 9 a 14kg.\n\nAbsorve até 4 copos (1 copo=50ml), garantindo até 12h de proteção. As barreiras duplas evitam vazamentos laterais.",
    keyFeatures: ["Uso Noturno", "9 a 14kg", "Até 12h"],
    seoKeywords: ["mamypoko g 50", "dia e noite g"]
  },
  // 10. MamyPoko Fralda-Calça Premium Seca G – 50 un
  {
    id: 'mamy-prem-g-50',
    brand: 'Mamypoko',
    name: "MamyPoko Fralda-Calça Premium Seca G – 50 un",
    line: Line.MamyPokoPremium,
    category: "Pants (Calça)",
    size: "G",
    units: 50,
    imageUrl: "https://m.media-amazon.com/images/I/711VJddUaVL._AC_SY300_SX300_QL70_ML2_.jpg",
    affiliateUrl: "https://amzn.to/44wU20K",
    shortDescription: "Ondas de absorção e toque suave.",
    fullDescription: "## ☁️ CONFORTO E TECNOLOGIA\n\nPara bebês de 9 a 14kg.\n\nCombina as ondas de absorção imediata com barreiras duplas para máxima segurança. Mantém o bebê sequinho por até 12h.",
    keyFeatures: ["Ondas de Absorção", "Toque Suave", "Premium"],
    seoKeywords: ["mamypoko premium g", "fralda calça g"]
  },
  // 11. MamyPoko Fralda-Calça Premium Seca G – 60 un
  {
    id: 'mamy-prem-g-60',
    brand: 'Mamypoko',
    name: "MamyPoko Fralda-Calça Premium Seca G – 60 un",
    line: Line.MamyPokoPremium,
    category: "Pants (Calça)",
    size: "G",
    units: 60,
    imageUrl: "https://m.media-amazon.com/images/I/7145nK-C+ML._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/3MCbnPK",
    shortDescription: "Mega pacote Premium G. Absorve até 5 copos.",
    fullDescription: "## 📦 MEGA PACOTE PREMIUM\n\nMesma tecnologia Premium Seca em embalagem maior.\n\nPara bebês de 9 a 14kg, absorve até 5 copos de 50ml, garantindo tranquilidade por mais tempo.",
    keyFeatures: ["Mega Pacote", "Até 5 Copos", "Premium"],
    seoKeywords: ["mamypoko g 60", "premium seca g"]
  },
  // 12. MamyPoko Fralda-Calça Dia & Noite XG – 42 un
  {
    id: 'mamy-dn-xg-42',
    brand: 'Mamypoko',
    name: "MamyPoko Fralda-Calça Dia & Noite XG – 42 un",
    line: Line.MamyPokoDiaNoite,
    category: "Pants (Calça)",
    size: "XG",
    units: 42,
    imageUrl: "https://m.media-amazon.com/images/I/71Z0pO4yDRL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/4jjaJmF",
    shortDescription: "Proteção XG até 12h. Fita de descarte prática.",
    fullDescription: "## 🛡️ PROTEÇÃO XG\n\nPara bebês de 12 a 17kg.\n\nProteção robusta que absorve até 4 copos de 60ml. Ideal para noites longas sem vazamentos.",
    keyFeatures: ["12 a 17kg", "Até 4 Copos", "Dia & Noite"],
    seoKeywords: ["mamypoko xg", "dia e noite xg"]
  },
  // 13. MamyPoko Fralda-Calça Premium Seca XG – 26 un
  {
    id: 'mamy-prem-xg-26',
    brand: 'Mamypoko',
    name: "MamyPoko Fralda-Calça Premium Seca XG – 26 un",
    line: Line.MamyPokoPremium,
    category: "Pants (Calça)",
    size: "XG",
    units: 26,
    imageUrl: "https://m.media-amazon.com/images/I/71J7sWvZn5L._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/45c1luV",
    shortDescription: "Uso prolongado com ondas de absorção. 12-17kg.",
    fullDescription: "## ⏳ USO PROLONGADO\n\nPara bebês de 12 a 17kg.\n\nAs ondas de absorção permitem o uso prolongado mantendo a pele seca. Absorve até 5 copos de 60ml.",
    keyFeatures: ["Uso Prolongado", "Ondas de Absorção", "XG"],
    seoKeywords: ["mamypoko premium xg", "fralda xg"]
  },
  // 14. MamyPoko Fralda-Calça Dia & Noite XG – 52 un
  {
    id: 'mamy-dn-xg-52',
    brand: 'Mamypoko',
    name: "MamyPoko Fralda-Calça Dia & Noite XG – 52 un",
    line: Line.MamyPokoDiaNoite,
    category: "Pants (Calça)",
    size: "XG",
    units: 52,
    imageUrl: "https://m.media-amazon.com/images/I/7108hxbaBnL._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/3L1ON2w",
    shortDescription: "Pacote econômico XG. Cintura elástica 2x.",
    fullDescription: "## 🤸 LIBERDADE XG\n\nPara bebês de 12 a 17kg.\n\nCintura elástica que estica até 2x, proporcionando conforto total para bebês maiores que se movimentam muito.",
    keyFeatures: ["Pacote Econômico", "Cintura Elástica", "12h Sequinho"],
    seoKeywords: ["mamypoko xg 52", "dia e noite atacado"]
  },
  // 15. MamyPoko Fralda-Calça Premium Seca XXG – (15 a 26kg)
  {
    id: 'mamy-prem-xxg-big',
    brand: 'Mamypoko',
    name: "MamyPoko Fralda-Calça Premium Seca XXG",
    line: Line.MamyPokoPremium,
    category: "Pants (Calça)",
    size: "XXG",
    units: 0, // Unidade varia por pacote, input não especificou. Deixando genérico ou ajustar se souber. Input diz apenas XXG
    imageUrl: "https://m.media-amazon.com/images/I/61Lg9n4E5XS._AC_SX569_.jpg",
    affiliateUrl: "https://amzn.to/3Y0QYGu",
    shortDescription: "Para crianças de 15 a 26kg. Absorção gigante.",
    fullDescription: "## 🐘 TAMANHO GIGANTE\n\nPara bebês/crianças de 15 a 26kg.\n\nAbsorve até 5 copos de 70ml! Ideal para crianças maiores, garantindo 12h de pele seca com ondas de absorção imediata.",
    keyFeatures: ["15 a 26kg", "Até 5 Copos", "Premium"],
    seoKeywords: ["mamypoko xxg", "fralda xxg", "tamanho juvenil"]
  }
];
